import Main from 'js/views/main';

import { ConstructableView } from './types';

export const loadView = (
  views: Record<string, ConstructableView>,
  viewName: string,
): ConstructableView => views[viewName] || Main;

export const resolveViewName = (): string | null => {
  const viewName = document.getElementsByTagName('body')[0].dataset.jsViewName;
  return viewName || null;
};
